import { createFileRoute } from "@tanstack/react-router"
import { SITE_URL } from "@/lib/constants/site-url"
import { BAKERY_ADDRESS, BAKERY_EMAIL, SITE_NAME } from "@/lib/constants/site"
import ColabPage from "@/pages/colab"

const OG_IMAGE = `${SITE_URL}/images/plusbake/colab/influencer-collaboration-header2.jpg`

export const Route = createFileRoute("/$countryCode/colab")({
  head: () => {
    const title = "Influencer Collaboration | +Bake Cafe"
    const description =
      "Collaborate with the Take Ur Seat family of brands. Creator and influencer opportunities across +Bake Cafe, TUS, Gud2Go, and TUS Lite."
    const canonical = `${SITE_URL}/colab`

    const webPageSchema = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      name: title,
      url: canonical,
      description,
      about: {
        "@type": ["Bakery", "CafeOrCoffeeShop"],
        name: SITE_NAME,
        email: BAKERY_EMAIL,
        address: {
          "@type": "PostalAddress",
          streetAddress: BAKERY_ADDRESS.street,
          addressLocality: BAKERY_ADDRESS.city,
          addressRegion: BAKERY_ADDRESS.region,
          postalCode: BAKERY_ADDRESS.postalCode,
          addressCountry: BAKERY_ADDRESS.country,
        },
      },
    }

    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
        { "@type": "ListItem", position: 2, name: "Colab", item: canonical },
      ],
    }

    return {
      meta: [
        { title },
        { name: "description", content: description },
        { property: "og:title", content: title },
        { property: "og:description", content: description },
        { property: "og:type", content: "website" },
        { property: "og:url", content: canonical },
        { property: "og:image", content: OG_IMAGE },
        { property: "og:site_name", content: SITE_NAME },
        { name: "twitter:card", content: "summary_large_image" },
        { name: "twitter:title", content: title },
        { name: "twitter:description", content: description },
        { name: "twitter:image", content: OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: canonical }],
      scripts: [
        { type: "application/ld+json", children: JSON.stringify(webPageSchema) },
        { type: "application/ld+json", children: JSON.stringify(breadcrumbSchema) },
      ],
    }
  },
  component: ColabPage,
})
